import {
  Avatar,
  Box,
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Typography,
  useTheme,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { imgUrl } from 'src/Helpers/utils/Constant';
import { ITraineeDraftApplicationListItem } from '../types/traineeDraftApplicationTypes';

interface IProps {
  sl: number;
  traineeDraftApplication: ITraineeDraftApplicationListItem;
}

const TraineeDraftTableRow = ({ sl, traineeDraftApplication }: IProps) => {
  const theme = useTheme();

  return (
    <TableRow hover>
      <TableCell>
        <Typography variant='body1' fontWeight='bold' color='text.primary' noWrap>
          {sl}
        </Typography>
      </TableCell>
      <TableCell>
        <Box display='flex' alignItems='center' gap={1.5}>
          <Avatar
            src={
              traineeDraftApplication.training_course_application_photo
                ? `${imgUrl}/${traineeDraftApplication.training_course_application_photo}`
                : '/static/images/avatars/avatar2.png'
            }
            alt={traineeDraftApplication.training_course_application_name}
            sx={{ width: 40, height: 40 }}
          />
          <Box>
            <Typography variant='body1' fontWeight='bold' color='text.primary'>
              {traineeDraftApplication.training_course_application_name}
            </Typography>
            {traineeDraftApplication.training_course_application_trainee_id && (
              <Link
                to={`/training-trainee/details/${traineeDraftApplication.training_course_application_trainee_id}`}
                style={{ textDecoration: 'none' }}
              >
                <Typography variant='caption' color='primary'>
                  Trainee ID: {traineeDraftApplication.training_course_application_trainee_id}
                </Typography>
              </Link>
            )}
          </Box>
        </Box>
      </TableCell>
      <TableCell>
        <Typography
          variant='body2'
          color='text.primary'
          sx={{
            maxWidth: 280,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={traineeDraftApplication.atab_training_course_name}
        >
          {traineeDraftApplication.atab_training_course_name || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant='body2' color='text.primary'>
          {traineeDraftApplication.user_member_company_name || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant='body2' color='text.primary'>
          {traineeDraftApplication.training_course_application_mobile || 'N/A'}
        </Typography>
        <Typography variant='caption' color='text.secondary'>
          {traineeDraftApplication.training_course_application_email || ''}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant='body2' color='text.secondary'>
          {traineeDraftApplication.training_course_application_created_at
            ? dayjs(traineeDraftApplication.training_course_application_created_at).format('DD-MMM-YYYY')
            : 'N/A'}
        </Typography>
      </TableCell>
      <TableCell align='center'>
        <Link
          to={`/training-trainee/draft-application/details/${traineeDraftApplication.training_course_application_draft_id}`}
        >
          <Tooltip title='View Draft Details' arrow>
            <IconButton
              sx={{
                '&:hover': {
                  background: theme.colors.primary.lighter,
                },
                color: theme.palette.primary.main,
              }}
              color='inherit'
              size='small'
            >
              <VisibilityIcon fontSize='small' />
            </IconButton>
          </Tooltip>
        </Link>
      </TableCell>
    </TableRow>
  );
};

export default TraineeDraftTableRow;
